/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Injector} from '../di/injector';
import {Type} from '../type';

import {ComponentFactoryResolver} from './component_factory_resolver';
/**
 * Represents an instance of an NgModule created via a {\@link NgModuleFactory}.
 * 
 * `NgModuleRef` provides access to the NgModule Instance as well other objects related to this
 * NgModule Instance.
 * 
 * \@stable
 * @abstract
 */
export abstract class NgModuleRef<T> {
/**
 * The injector that contains all of the providers of the NgModule.
 * @abstract
 * @return {?}
 */
injector() {}
/**
 * The ComponentFactoryResolver to get hold of the ComponentFactories
 * declared in the `entryComponents` property of the module.
 * @abstract
 * @return {?}
 */
componentFactoryResolver() {}
/**
 * The NgModule instance.
 * @abstract
 * @return {?}
 */
instance() {}
/**
 * Destroys the module instance and all of the data structures associated with it.
 * @abstract
 * @return {?}
 */
destroy() {}
/**
 * Allows to register a callback that will be called when the module is destroyed.
 * @abstract
 * @param {?} callback
 * @return {?}
 */
onDestroy(callback: () => void) {}
}

export interface InternalNgModuleRef<T> extends NgModuleRef<T> {
  // Note: we are using the prefix _ as NgModuleData is an NgModuleRef and therefore directly
  // exposed to the user.
  _bootstrapComponents: Type<any>[];
}
/**
 * \@experimental
 * @abstract
 */
export abstract class NgModuleFactory<T> {
/**
 * @abstract
 * @return {?}
 */
moduleType() {}
/**
 * @abstract
 * @param {?} parentInjector
 * @return {?}
 */
create(parentInjector: Injector|null) {}
}



// WEBPACK FOOTER //
// ../../../../packages/core/src/linker/ng_module_factory.ts